import { render, staticRenderFns } from "./LicenseHistory.vue?vue&type=template&id=804b3f3a&"
import script from "./LicenseHistory.vue?vue&type=script&lang=js&"
export * from "./LicenseHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports